(ns renolit-roofing-service.shared.localization.dictionaries.es.notifications-templates.event
  (:require [clojure.pprint :refer [cl-format]]))

(def registry
  {:service-requested
   {:installer
    {:websocket
     {:template
      (fn [[{:keys []}]]
        (cl-format nil "Se solicitó un nuevo servicio"))}}}
   :samples-taken
   {:laboratory
    {:websocket
     {:template
      (fn [[{:keys []}]]
        (cl-format nil "Nuevo informe de campo realizado"))}}}
   :samples-analyzed
   {:rae
    {:websocket
     {:template
      (fn [[{:keys []}]]
        (cl-format nil "Muestras analizadas"))}}}})
